// AGC: FarmProHub Bottom Navigation Component
// AGC: 5 items: Forum, Proposals, Revenues, Docs, Analytics

import React from 'react'
import { MessageSquare, Vote, TrendingUp, FileText, BarChart3 } from 'lucide-react'

export type BottomNavKey = 'forum' | 'proposals' | 'revenues' | 'docs' | 'analytics'

interface BottomNavProps {
  activeNav: BottomNavKey
  onNavClick: (nav: BottomNavKey) => void
}

const NAV_ITEMS: Array<{ id: BottomNavKey; label: string; icon: React.ComponentType<{ className?: string }> }> = [
  { id: 'forum', label: 'Forum', icon: MessageSquare },
  { id: 'proposals', label: 'Proposals', icon: Vote },
  { id: 'revenues', label: 'Revenues', icon: TrendingUp },
  { id: 'docs', label: 'Docs', icon: FileText },
  { id: 'analytics', label: 'Analytics', icon: BarChart3 },
]

/**
 * AGC: FarmProHub bottom navigation bar.
 * AGC: Provides quick access to primary sections with consistent styling.
 */
export const BottomNav: React.FC<BottomNavProps> = ({ activeNav, onNavClick }) => {
  return (
    <nav className="fixed bottom-0 left-0 w-full h-[64px] bg-slate-900/90 backdrop-blur-md border-t border-slate-800/60 flex justify-around items-center text-xs font-medium z-40 shadow-[0_-4px_12px_rgba(0,0,0,0.5)]">
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon
        const isActive = activeNav === item.id
        return (
          <button
            key={item.id}
            onClick={() => onNavClick(item.id)}
            className={`flex flex-col items-center gap-1 transition-colors ${
              isActive ? 'text-[#0072CE]' : 'text-slate-400 hover:text-slate-200'
            }`}
          >
            <Icon className="w-5 h-5" />
            {item.label}
          </button>
        )
      })}
    </nav>
  )
}

